import { Asset } from "./asset";
import { Recordtype } from "./recordtype";
import { SystemField } from "./system-field";

export class Section  extends SystemField{
    
	name?: string;
	type?: string;
	bg_img?: string;
	bg_color?: string;
	bg_video?: string;
	parent_id?: string;
	ordering?: number;
	edit_bg_image?: number;
	site_pages_id?: string;
	image_preview_c?: File[];

    record_type?: Recordtype; //info-image, 
	/**
	 * record type?: value
	 * - slide 			?: For section has sub-section (mostly the section that has slide)
	 * - info 			?: For section display title, sub-title, short-description
	 * - info-asset		?: For section display title, sub-title, short-description and other assets
	 * - info-image		?: For section display title, sub-title, short-description and an image
	 * - title			?: For section display only title
	 * - image			?: For section display only image
	 * - info-rich-image?: For Section display title, sub-title, short-description, an image and richtext
	 */

	// Formula Fields
	bg_img_file?: File;
	bg_img_preview?: string;

	// Callback class
	assets?: Asset[];
	sections?: Section[];
	sub_sections?: Section[];

	// Import class translate
	langs?: any;
}


export class SectionTranslation  extends SystemField{
	 
	lang_code?: string;
	title?: string;
	subtitle?: string;
	short_desc?: string;
	contents?: string;
	sections_id?: string;
}
